<table class="table">
  <thead>
    <tr>
      @for (item of columns; track item) {
        <th [style.width]="item.width">
          {{ labelService.getLabel(item.name) }}
        </th>
      }
      @for (item of buttons_firstSet; track item) {
        <th></th>
      }
    </tr>
  </thead>

  <tbody>
    @for (itemRow of tableData; track itemRow) {
      <tr>
        @for (item of columns; track item) {
          <td>
            @if (item.name === "title" && tableTitle === "appointments") {
              <span (click)="columnClicked(itemRow)" style="cursor: pointer">{{
                itemRow.title
              }}</span>
            } @else {
              {{ itemRow[item.name] }}
            }
          </td>
        }
        @for (button of buttons; track button) {
          <td>
            @if (
              button !== "visibility" ||
              (button === "visibility" &&
                itemRow.file_content_type.includes("pdf"))
            ) {
              <span
                style="cursor: pointer"
                class="material-icons"
                (click)="buttonClicked(button, itemRow)"
                [title]="getButtonActionDescription(button)"
              >
                {{ button }}
              </span>
            }
          </td>
        }
      </tr>
    }
  </tbody>
</table>
